import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthLayout from './AuthLayout';
import { LabeledField } from '@/__core/components/LabeledField';

// UI Component
interface ForgotPasswordFormProps {
  username: string;
  error: string;
  success: string;
  onUsernameChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  onBack: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  username,
  error,
  success,
  onUsernameChange,
  onSubmit,
  onBack,
}) => {
  return (
 
    <>
        <Typography variant="h5" align="center" mb={3} fontWeight={700}>
          Quên mật khẩu
        </Typography>
        {error && <Box color="error.main" mb={2}>{error}</Box>}
        {success && <Box color="success.main" mb={2}>{success}</Box>}
        <form onSubmit={onSubmit}>
          <Stack spacing={3}>
            <LabeledField label="Nhập email" labelWidth={80}>
              <TextField
                value={username}
                onChange={(e) => onUsernameChange(e.target.value)}
                fullWidth
                required
                autoFocus
                size='small'
              />
            </LabeledField>
            <br />
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                color="success"
                fullWidth
                onClick={onBack}
                sx={{ fontWeight: 'bold', fontSize: 16 }}
                size='small'
              >
                Quay lại
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="success"
                fullWidth
                sx={{ fontWeight: 'bold', fontSize: 16 }}
                size='small'
              >
                Lấy mật khẩu
              </Button>
            </Stack>
          </Stack>
        </form>
      </>
  );
};

// Logic Component
const ForgotPassword = () => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!username) {
      setError('Vui lòng nhập tên đăng nhập');
      return;
    }
    try {
      const res = await axios.post(`${API_BASE_URL}/accounts/request-password-reset/`, { username });
      setSuccess(res.data.message || 'Nếu tài khoản tồn tại và có email, hướng dẫn đã được gửi.');
      setUsername("");
    } catch (err: any) {
      setError('Có lỗi xảy ra, vui lòng thử lại.');
    }
  };

  return (
    <AuthLayout>
      <ForgotPasswordForm
        username={username}
        error={error}
        success={success}
        onUsernameChange={setUsername}
        onSubmit={handleSubmit}
        onBack={() => navigate('/auth/login')}
      />
    </AuthLayout>
  );
};

export default ForgotPassword; 